export default {
      id: "icon-dus-ve-wc-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-dus-ve-wc",
      toString: function () {
        return this.url;
      }
    }